export const calculateTimeTrading = (
  startDateMonth?: string,
  startDateYear?: string,
) => {
  const dateNow = new Date();
  const startYear = Number(startDateYear) || dateNow.getFullYear();
  const startMonth = Number(startDateMonth) || dateNow.getMonth() + 1;

  const startDate = new Date(startYear, startMonth - 1);

  let years = dateNow.getFullYear() - startDate.getFullYear();
  let months = dateNow.getMonth() - startDate.getMonth();

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  years = Math.max(0, years);
  months = Math.max(0, months);

  return { years, months };
};
